<span class="snack-bar-close-action" matSnackBarActions>
  <mat-icon
    class="snack-bar-close-icon"
    (click)="close()"
    aria-label="Close"
    matButton
    matSnackBarAction
    >cancel</mat-icon
  >
</span>
<span class="snack-bar-message" matSnackBarLabel>{{ data.message }}</span>
